import { render, staticRenderFns } from "./MetaDataView.vue?vue&type=template&id=68d43f7f&scoped=true&"
import script from "./MetaDataView.vue?vue&type=script&lang=ts&"
export * from "./MetaDataView.vue?vue&type=script&lang=ts&"
import style0 from "./MetaDataView.vue?vue&type=style&index=0&id=68d43f7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d43f7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VAlert,VFlex,VIcon})
